import type {Action} from 'src/action-creators/product-flags';
import {RECEIVE_RELEASE_FLAGS} from 'src/action-creators/product-flags';


export type ProductFlagState = {
  releaseFlags: {
    [key: string]: boolean;
  };
};

const initialState: ProductFlagState = {
  releaseFlags: Object.freeze({}),
};

export default (
  state: ProductFlagState | null | undefined = initialState,
  action: Action,
): ProductFlagState => {
  switch (action.type) {
    case RECEIVE_RELEASE_FLAGS:
      return {
        ...state,
        releaseFlags: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.releaseFlags,
          ...action.payload,
        },
      };
  }

  // @ts-expect-error - TS2322 - Type 'ProductFlagState | null' is not assignable to type 'ProductFlagState'.
  return state;
};
